import { Controller } from 'stimulus'
import Sortable from 'sortablejs'
import ujs from '@rails/ujs'

export default class extends Controller {
    connect() {
        const self = this

        const group = this.data.get('group') ?? 'sortable-list'
        const allowCrossGroup = this.data.get('allowCrossGroup') === 'true' // default is false

        this.notified = false // used to throttle the warning toast

        this.sortable = Sortable.create(this.element, {
            group: group,
            filter: '[data-role="list-action-buttons"]',
            handle: '.grabber',
            forceFallback: true,
            ghostClass: 'u-ghosted',
            chosenClass: 'u-dragging',
            direction: 'vertical',

            onMove: function (ev) {
                // Prevent dropping above "add new" buttons
                if (ev.related?.dataset.role === 'list-action-buttons') {
                    return -1
                }

                // Cross-group protection (opt-in only)
                if (!allowCrossGroup) {
                    const draggedGroup = ev.dragged.dataset.group
                    const targetGroup = ev.related?.dataset.group

                    if (draggedGroup && targetGroup && draggedGroup !== targetGroup) {
                        ev.dragged.classList.add('sortable-blocked')
                        setTimeout(() => {
                            ev.dragged.classList.remove('sortable-blocked')
                        }, 300)

                        return false
                    }
                }
            },

            onEnd: function (ev) {
                processMove(self, ev)
            }
        })
    }
}

function processMove(controller, ev) {
    if (ev.newIndex !== ev.oldIndex) {
        const url = ev.item.dataset.rankUrl
        if (url) {
            var fd = new FormData()
            fd.append('_method', 'put')
            fd.append('rank', ev.newIndex)
            ujs.ajax({
                url: url,
                type: 'post',
                dataType: 'script',
                data: fd
            })
        } else {
            window.dispatchEvent(ev)
        }
    }
}
